import { useMutation } from "@tanstack/react-query";
import { ChangeEvent, useState } from "react";
import { Button, Card, Input } from "tvs-unified-lib";
import { useNavigate } from "react-router-dom";
import { postData } from "@/utils/apiProvider";
import { AuthResponse } from "@/store/types";
import useAuthStore from "@/store/authStore";

export default function Login() {
  // const [email, setEmail] = useState("");
  // const [pass, setPass] = useState("");
  // const navigate = useNavigate();
  // const { setAuth, setToken } = useAuthStore();
  // const mutation = useMutation({
  //   mutationFn: async () => {
  //     return postData("cms/login", { email, password: pass });
  //   },
  // });

  // return (
  //   <>
  //     <Card>
  //       <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
  //         <Input
  //           name="email"
  //           formLabel="Email"
  //           value={email}
  //           onInputChange={(e: ChangeEvent) =>
  //             setEmail((e.target as HTMLInputElement).value)
  //           }
  //         />
  //         <Input
  //           name="password"
  //           formLabel="Password"
  //           value={pass}
  //           onInputChange={(e: ChangeEvent) =>
  //             setPass((e.target as HTMLInputElement).value)
  //           }
  //         />
  //         <Button
  //           type="submit"
  //           onClick={() =>
  //             mutation.mutate(null, {
  //               onSuccess: (data: AuthResponse) => {
  //                 setAuth(data);
  //                 setToken(data?.user?.access_token);
  //                 navigate("/");
  //               },
  //               onError: (error) => {
  //                 alert(`Error occurred ${JSON.stringify(error)}`);
  //               },
  //             })
  //           }
  //           theme="purple"
  //           fullWidth={false}
  //           variant="block"
  //           label="Submit"
  //         />
  //       </div>
  //     </Card>
  //   </>
  // );
  return <div>Login</div>;
}
